export const isFoilTemplate = (template: { themeId: string }) => {
  return template.themeId.endsWith('_foil');
};
